module.exports = __webpack_public_path__ + "static/media/maps-and-flags.5588985a.svg";